import { globalStore } from "@/store";

export async function adminGuard(to, from, next) {
  try {
    const admin = await globalStore.dispatch("loadAdmin");

    if (admin) {
      next();
      return;
    }

    next({ name: "login" });
  } catch {
    next({ name: "login" });
  }
}
